// extracted by mini-css-extract-plugin
export default {"melodyVideo":"JM-z","isFullWidth":"KM-z","landingPageVideo":"LM-z","play":"MM-z","iframeVideo":"NM-z","playHidden":"OM-z","fullwidth":"PM-z"};